module.exports = __webpack_public_path__ + "static/HeroImage-98b15d85f1f7da7bc1cb940db999564c.svg";